import valueFilters from '../valueFilters';
import util from '../util';
import validator from '../validator';
import modelFactory from '../modelFactory';

export interface IVendorCostFactor {
	key?: string;
	description?: string;
	value?: number;
}

const vendorCostFactorFactory = modelFactory.createFactory<IVendorCostFactor>('VendorCostFactor', {
	key: {
		defaultValue: util.generateGuid // Note: only valid for GuidKeyModels. KeyNameModels should override this
	},
	description: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: [validator.required(), validator.greaterThan(0)]
	}
});

export default vendorCostFactorFactory;